import type { Bonus, PreviewPage, Volume } from '../types/content';
export const volumes: Volume[] = [{
  label: "VOLUMEN 01",
  title: 'RESET DE FRICCIÓN MENTAL',
  subtitle: '',
  items: ['Cortás antes pensamientos que se repiten una y otra vez.', 'Tenés resets de 60 segundos, 3, 5 y 10 minutos.', 'Volvés rápidamente a una próxima acción útil.'],
  result: '“Dejo de darle vueltas y vuelvo a lo que puedo hacer ahora.”',
  accent: 'info'
}, {
  label: "VOLUMEN 02",
  title: 'DESAPEGO PRÁCTICO',
  subtitle: '',
  items: ['Separás lo que depende de vos de lo que depende de otros.', 'Sabés cuándo actuar, esperar, insistir o soltar.', 'Dejás de poner tu tranquilidad en manos de respuestas y resultados externos.'],
  result: '“Sé qué me corresponde hacer y qué puedo dejar de cargar.”',
  accent: 'primary'
}, {
  label: "VOLUMEN 03",
  title: 'CALMA EN SITUACIONES REALES',
  subtitle: '',
  items: ['Tenés respuestas preparadas para trabajo, pareja, familia y WhatsApp.', 'Sabés qué hacer ante críticas, discusiones, demoras y cambios de planes.', 'Encontrás frases concretas para responder sin improvisar bajo presión.'],
  result: '“Cuando pasa algo, ya sé cómo responder.”',
  accent: 'highlight'
}, {
  label: "VOLUMEN 04",
  title: 'INTEGRACIÓN DE CALMA COTIDIANA',
  subtitle: '',
  items: ['Tenés rutinas preparadas de 5, 12 y 20 minutos.', 'Seguís un programa guiado de 21 días.', 'Usás reinicios de 24 horas o 3 días cuando necesitás volver a tu eje.'],
  result: '“Tengo una forma simple de aplicar calma en mi día a día.”',
  accent: 'danger'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/tiiMAwjBhqycfkuv6df6qR/1.webp',
  alt: 'Página: Primero, separá el hecho de la historia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wrUWCnTUByUWknrnynAfFn/2.webp',
  alt: 'Página: Pensar más no te da más control'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7xY3XZE1CrgUk5awAMh3VB/3.webp',
  alt: 'Página: Paso 2, soltar'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bapCSREVw3joxeNssPJkgj/4.webp',
  alt: 'Página: Protocolo 10, sentís que perdiste tiempo'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'BOTIQUÍN DE CALMA INMEDIATA',
  detail: '',
  items: ['Tenés 15 intervenciones rápidas listas para usar.', 'Elegís opciones de 1 a 5 minutos según el momento.', 'Actuás rápido ante frustración, enojo, espera o saturación.'],
  value: '$12.000'
}, {
  number: '02',
  title: 'CONVERSACIONES SIN CARGA',
  detail: '',
  items: ['Tenés respuestas para decir que no y poner límites.', 'Elegís entre versiones cordiales, directas y firmes.', 'Cerrás conversaciones sin justificarte de más.'],
  value: '$10.000'
}, {
  number: '03',
  title: 'DECISIONES SIN SOBREPENSAR',
  detail: '',
  items: ['Sabés cuándo responder, esperar, insistir o soltar.', 'Usás árboles de decisión ya resueltos.', 'Evitás revisar mentalmente una decisión una y otra vez.'],
  value: '$11.000'
}, {
  number: '04',
  title: 'CIERRE MENTAL NOCTURNO',
  detail: '',
  items: ['Cerrás mentalmente discusiones, errores y pendientes.', 'Dejás preparado lo que corresponde continuar mañana.', 'Seguís una secuencia nocturna organizada de 7 días.'],
  value: '$9.000'
}, {
  number: '05',
  title: 'TARJETAS CALMA APLICADA',
  detail: '',
  items: ['Tenés 30 tarjetas para situaciones cotidianas.', 'Consultás rápidamente qué recordar y qué hacer.', 'Llevás las respuestas principales en tu celular o impresas.'],
  value: '$10.000'
}];